import React from 'react';
import { Switch, withStyles } from "@material-ui/core";

export const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 52,
    height: 30,
    padding: 0,
    marginLeft: "16px"
  },
  switchBase: {
    padding: '0 !important',
    top: '1.5px',
    left: '2.5px',
    '&$checked': {
      left: '0',
      transform: 'translateX(24px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#4A9EDB',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#4A9EDB',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 26,
    height: 26,
  },
  track: {
    borderRadius: 30 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, name, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      name={name}
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});